import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, scroll to top.
 * Mount once, in the App router root.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    try { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }
    catch { window.scrollTo(0, 0); }
  }, [pathname]);
  return null;
}
